var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('router-link',{attrs:{"to":"/"}},[_c('h2',[_c('Logo'),_c('span',[_vm._v(_vm._s(_vm.$config.common.title))])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }